/* iliac AJAX cart drawer
   Place in /assets/iliac-cart.js and load once in theme.liquid (after the drawer snippet):
   {% render 'iliac-cart-drawer' %}
   <script src="{{ 'iliac-cart.js' | asset_url }}" defer></script>
*/
(function () {
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format((cents || 0) / 100); }
    catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
  }
  function esc(s) { return (s || '').replace(/"/g, '&quot;'); }

  var drawer, body, foot, subtotalEl;

  function q() {
    drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) {
      body = drawer.querySelector('[data-cart-body]');
      foot = drawer.querySelector('[data-cart-foot]');
      subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    }
    return drawer;
  }

  function setCounts(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-on', n > 0);
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  function itemHTML(it) {
    var img = it.image || (it.featured_image && it.featured_image.url) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var opt = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="icart-item__opt">' + it.variant_title + '</div>' : '';
    return '<div class="icart-item" data-key="' + esc(it.key) + '">' +
      '<a class="icart-item__media" href="' + it.url + '"><img src="' + img + '" alt="' + esc(it.product_title) + '" loading="lazy"></a>' +
      '<div class="icart-item__info">' +
        '<a class="icart-item__title" href="' + it.url + '">' + it.product_title + '</a>' + opt +
        '<div class="icart-item__row">' +
          '<div class="icart-item__qty">' +
            '<button type="button" data-qty-dec aria-label="Decrease">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-qty-inc aria-label="Increase">+</button>' +
          '</div>' +
          '<div class="icart-item__price">' + money(it.final_line_price) + '</div>' +
        '</div>' +
        '<button class="icart-item__remove" type="button" data-remove>Remove</button>' +
      '</div>' +
    '</div>';
  }

  function render(cart) {
    if (!body) q();
    if (!body) return;
    setCounts(cart.item_count);
    if (!cart.item_count) {
      body.innerHTML = '<div class="icart__empty"><p class="icart__emptyTitle">Your cart is empty.</p><p class="icart__emptyText">Explore the collection to get started.</p></div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    body.innerHTML = cart.items.map(itemHTML).join('');
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    if (foot) foot.style.display = '';
    body.querySelectorAll('.icart-item').forEach(function (row) {
      var key = row.getAttribute('data-key');
      var qty = parseInt(row.querySelector('.icart-item__qty span').textContent, 10) || 1;
      row.querySelector('[data-qty-dec]').addEventListener('click', function () { change(key, qty - 1); });
      row.querySelector('[data-qty-inc]').addEventListener('click', function () { change(key, qty + 1); });
      row.querySelector('[data-remove]').addEventListener('click', function () { change(key, 0); });
    });
  }

  function refresh() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(render); }

  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(render);
  }

  function open() { if (!drawer) q(); if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
  function close() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }

  window.IliacCart = { open: function () { refresh().then(open); }, close: close, refresh: refresh };

  /* Open/close via delegation so it works no matter when the header/drawer render */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-cart-open]')) { e.preventDefault(); window.IliacCart.open(); return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); close(); }
  });

  /* Intercept add-to-cart in the CAPTURE phase so the theme's native product form
     handler never runs (it would otherwise redirect to /cart). We own the add. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('disabled', 'disabled');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(function () { open(); })
      .catch(function () {})
      .then(function () { if (btn) btn.removeAttribute('disabled'); });
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function init() { q(); refresh(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', q);
})();